import apiClient from './client';
import {
  ErganiScheduleCheckResponse,
  ErganiScheduleDeleteResponse,
  ErganiScheduleOverrideResponse,
  ErganiWeeklyScheduleCheckResponse,
  ErganiWeeklyScheduleResponse,
} from 'interfaces/ergani';
import { erganiRequest } from './erganiCommon';

interface ErganiScheduleService {
  sendScheduleOverride(overrideId: string): Promise<ErganiScheduleOverrideResponse>;
  checkScheduleOverride(overrideId: string, signal?: AbortSignal): Promise<ErganiScheduleCheckResponse>;
  deleteScheduleOverride(overrideId: string): Promise<ErganiScheduleDeleteResponse>;
  checkWeeklySchedule(scheduleId: number): Promise<ErganiWeeklyScheduleCheckResponse>;
  sendWeeklySchedule(scheduleId: number): Promise<ErganiWeeklyScheduleResponse>;
}

const endpoints = {
  override: (id: string) => `/ergani/schedule/overrides/${id}`,
  overrideCheck: (id: string) => `/ergani/schedule/overrides/${id}/check`,
  weekly: (id: number) => `/ergani/schedule/${id}`,
  weeklyCheck: (id: number) => `/ergani/schedule/${id}/check`,
};

export const erganiScheduleServices: ErganiScheduleService = {
  sendScheduleOverride: (overrideId: string): Promise<ErganiScheduleOverrideResponse> =>
    erganiRequest(() => apiClient.post(endpoints.override(overrideId))),

  checkScheduleOverride: (overrideId: string, signal?: AbortSignal): Promise<ErganiScheduleCheckResponse> =>
    erganiRequest(() => apiClient.get(endpoints.overrideCheck(overrideId), { signal })),

  deleteScheduleOverride: (overrideId: string): Promise<ErganiScheduleDeleteResponse> =>
    erganiRequest(() => apiClient.delete(endpoints.override(overrideId))),

  checkWeeklySchedule: (scheduleId: number): Promise<ErganiWeeklyScheduleCheckResponse> =>
    erganiRequest(() => apiClient.get(endpoints.weeklyCheck(scheduleId))),

  sendWeeklySchedule: (scheduleId: number): Promise<ErganiWeeklyScheduleResponse> =>
    erganiRequest(() => apiClient.post(endpoints.weekly(scheduleId))),
};
